"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegerSelectList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * IntegerSelectList.tsx
 * Author: lnappenfeld
 * Date: 18.08.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const Input_1 = require("./Input");
const IntegerSelectList = (props) => {
    const [options, setOptions] = (0, react_1.useState)([]);
    // set value in parent component
    // useEffect(() => {
    //     const option = options.filter((x: any) => {
    //         return x.value === props.value;
    //     })[0];
    //     if (props.setValue) props.setValue(option);
    //     if (props.onChange) props.onChange(option);
    // }, []);
    (0, react_1.useEffect)(() => {
        console.log('useEffect: ', props.min);
        const tmpOptions = [];
        for (let i = props.min; i <= props.max; i++) {
            tmpOptions.push({ value: i.toString(), label: i.toString() });
        }
        setOptions(tmpOptions);
    }, []);
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { name: props.name ? props.name : 'integer_value', disabled: typeof props.disabled === 'boolean' ? props.disabled : false, edit: true, label: props.label, value: props.value, dropdownOptions: options, type: 'dropdown', onChange: (e) => {
            const option = options.filter((x) => {
                return x.value === e.value;
            })[0];
            if (props.setValue)
                props.setValue(option);
            if (props.onChange)
                props.onChange(option);
        }, validationControl: props.validationControl, validationErrorMessage: props.validationErrorMessage, validationRules: props.validationRules }));
};
exports.IntegerSelectList = IntegerSelectList;
